export default function Eye() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21.1548 11.8339C21.2065 11.917 21.2307 11.9715 21.2418 12C21.2307 12.0285 21.2065 12.083 21.1548 12.1661C21.0561 12.3249 20.8943 12.5289 20.6616 12.766C20.1979 13.2385 19.5066 13.788 18.6382 14.3109C16.8983 15.3585 14.531 16.25 12 16.25C9.46902 16.25 7.10169 15.3585 5.36183 14.3109C4.49337 13.788 3.80207 13.2385 3.33841 12.766C3.10572 12.5289 2.94386 12.3249 2.84522 12.1661C2.79353 12.083 2.76934 12.0285 2.75823 12C2.76934 11.9715 2.79353 11.917 2.84522 11.8339C2.94386 11.6751 3.10572 11.4711 3.33841 11.234C3.80207 10.7615 4.49337 10.212 5.36183 9.68909C7.10169 8.64149 9.46902 7.75 12 7.75C14.531 7.75 16.8983 8.64149 18.6382 9.68909C19.5066 10.212 20.1979 10.7615 20.6616 11.234C20.8943 11.4711 21.0561 11.6751 21.1548 11.8339Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="12" cy="12" r="2" fill="currentColor" />
        </svg>
    );
}
